import React from 'react';

import voissa1 from '../../images/historique/2000.png';
import voissa2 from '../../images/historique/voissatetons.jpg';
import voissa3 from '../../images/historique/2002.png';
import voissa4 from '../../images/historique/2004.png';
import voissa5 from '../../images/historique/2005.png';
import voissa6 from '../../images/historique/2006.png';
import voissa7 from '../../images/historique/2007.png';
import voissa8 from '../../images/historique/2009.png';
import voissa9 from '../../images/historique/2012.jpg';
import voissa11 from '../../images/historique/2014-2015.jpg';
import voissa12 from '../../images/historique/2022.jpg';
import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";

const History = (props) => {
    window.scrollTo(0, 0);
    return (
        <div id="history">
            <Helmet>
                <title>{config.preTitle}Historique{config.postTitle}</title>
            </Helmet>
            <div className="container">
                <div className="card big">
                    <Title heading={"heading-1"} display={"display-2"}>L'historique de Voissa en images</Title>

                    <div className="voissa-history-block">
                        <h3>2022 :</h3>
                        <p>Voissa fait peau neuve avec une complète refonte du site. Nouveau script et nouveau design pour assurer ses beaux jours.</p>
                        <img src={voissa12} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2014-2015 :</h3>
                        <p>La page d'accueil prend l'aspect d'un portail. Le menu évolue avec de jolis logos, intégrant
                            les histoires et les humeurs des Voissanautes.</p>
                        <img src={voissa11} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2012 :</h3>
                        <p>Voissa met à jour son script pour asseoir son succès de plus importante communauté de Charme.
                            L’accueil s’apparente au flux des réseaux sociaux bien connus, flux qui permet facilement de
                            trouver les contributions postées par les Voissanautes.</p>
                        <img src={voissa9} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2009-2012 :</h3>
                        <p>L’accueil de Voissa liste les contributions des Voissa créateur. Le design se simplifie afin
                            de proposer une plus grande qualité de navigation.</p>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2007-2009 :</h3>
                        <p>Voissa complète ses outils avec la possibilité d’envoyer ses vidéos, de créer un blog, de
                            discuter entre voissanautes. Le design était alors bien différent par rapport à aujourd’hui
                            mais les fonctionnalités préférées des Voissanautes arrivaient pour leur plus grand
                            plaisir.</p>
                        <img src={voissa8} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2006-2007 :</h3>
                        <p>Voissa propose désormais à ses visiteurs de partager leurs contributions. C’est une vraie
                            révolution car la communauté avait très hâte de pouvoir le faire. Le site s’oriente vers la
                            mode des réseaux sociaux (bien avant Facebook).</p>
                        <img src={voissa7} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2005-2006 :</h3>
                        <p>Le design est amélioré</p>
                        <img src={voissa6} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>NOVEMBRE 2005 : LANCEMENT DU JEU "VOISSA GLOTTE"</h3>
                        <p>Femme ou trans ? Nous avons décidé de vous faire éviter le pire... Grâce à nous, vous ne
                            ramènerez plus de "femmes à Kekette" à la maison ;o) Cherchez la glotte, observez leur
                            poitrine et identifiez la femme du trans'. L'heure est grave. Vous cherchez ce soir le
                            maillon faible.</p>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2004-2005 :</h3>
                        <p>Voissa améliore ses services, simplifie sa charte graphique et accueille de plus en plus de
                            monde avec près de 80 000 visiteurs uniques chaque jours. Un vrai succès !</p>
                        <img src={voissa5} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>AOUT 2003 : LANCEMENT DU CONCOURS "VOISSA SUMMER TATTOO"</h3>
                        <p>Voissa.com, le portail sexy n°1 du web francophone (source NetValue) annonce la finale du
                            grand concours de l’été Voissa Summer Tattoo. Ce challenge permet de fédérer les visiteurs
                            du portail autour d’un thème simple, sexy et festif en adéquation avec la période estivale.
                            Ludique, original et totalement nouveau, le concours a pour but de récompenser les
                            internautes les plus créatifs qui prennent en photo des situations rigolotes, insolites ou
                            sexy mettant en scène des individu(e)s ayant la mention « Voissa » inscrite sur le corps.
                            Les meilleurs clichés sont élus par les votes des visiteurs de VOISSA.COM. Avec plus de 300
                            images envoyées et 180 000 visiteurs en deux mois, l’événement remporte un vif succès. La
                            finale de ce grand concours aura lieu dans la semaine du 8 au 14 septembre et départagera
                            les photos gagnantes de chacune des six manches.</p>
                    </div>

                    <div className="voissa-history-block">
                        <h3>2002-2004 :</h3>
                        <p>Voissa devient un véritable portail, avec de plus en plus de services gratuits pour ses
                            visiteurs. Le site a déjà plus de 50 000 visiteurs fidèles tous les jours. Le logiciel «
                            Voissa no pubs » devient un énorme succès sur les plateformes de téléchargement, un vrai
                            service pour les amateurs de sexe qui souhaitent rester anonyme ;)</p>
                        <img src={voissa4} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>SEPTEMBRE 2002 : LANCEMENT DU LOGICIEL "VOISSA ANONYMO"</h3>
                        <p>Le saviez-vous ? Votre ordinateur enregistre temporairement toutes les adresses internet des
                            sites visités ainsi que tout ce qui apparaît sur l'écran quand vous surfez sur le web
                            (photos, vidéos...). Voissa Anonymo vous permet d'anonymiser votre machine en deux clics.
                            Ainsi, personne de votre entourage ne pourra voir les sites visités, les documents que vous
                            avez ouverts etc…</p>

                    </div>

                    <div className="voissa-history-block">
                        <h3>AOUT 2002 : LANCEMENT DU JEU "VOISSA TÉTONS II"</h3>
                        <p>Voici la suite du désormais célèbre Voissa Téton. 20 nouvelles poitrines et toujours une
                            question et une seule : tous ces seins sont-ils vraiment naturels ou bien siliconés ? La
                            partie Super Banco déterminera les meilleurs d’entre vous. Une jolie surprise attend tous
                            les joueurs ayant un score supérieur à 14 !</p>
                    </div>

                    <div className="voissa-history-block">
                        <h3>FÉVRIER 2002 : LANCEMENT DU LOGICIEL "VOISSA NO PUBS"</h3>
                        <p>Voissa No Pubs est un logiciel totalement gratuit (aucune limitation) qui rend la recherche
                            sur Internet plus rapide, plus agréable et plus efficace. En effet, la pollution
                            publicitaire est de plus en plus encombrante. Voissa No Pubs s'installe en tache de fond et
                            détecte les nouvelles fenêtres ouvertes. Si celles-ci font partie de la liste des Pop-Up
                            déjà connus (que vous pouvez augmenter), elles seront immédiatement fermées.</p>

                    </div>

                    <div className="voissa-history-block">
                        <h3>2000-2002 :</h3>
                        <p>Le site reste un annuaire qui sélectionner les meilleurs sites de sexe, mais le design
                            s’oriente vers le bleu. Un forum vient s’ajouter pour permettre à nos visiteurs fidèles
                            d’échanger entre eux. Une section « Jeux » et « Goodies » avait aussi beaucoup de succès
                            !</p>
                        <img src={voissa3} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>NOVEMBRE 1999 : LANCEMENT DU JEU "VOISSA TÉTONS"</h3>
                        <p>Sauriez vous différencier des seins silliconnés et des seins 100% naturel ?</p>
                        <img src={voissa2} alt=""/>
                    </div>

                    <div className="voissa-history-block">
                        <h3>1999-2000 :</h3>
                        <p>Voissa est le premier site dédié au charme (Google a été créé en 1998 !). Notre idée était de
                            lister les sites de sexe gratuits dans un annuaire. La qualité de notre sélection a été un
                            succès immédiat pour Voissa.</p>
                        <img src={voissa1} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default History;
